import BeneficiaryAssignment from './household/BeneficiaryAssignment';
import Beneficiary from './household/Beneficiary';
import Trust from './household/Trust';
import Will from "./household/Will";
import Asset from "./household/Asset";
import Individual from "./household/Individual";
import IavAccount from "./household/IavAccount";
import Property from "./household/Property";
import LifeInsurance from "./household/LifeInsurance";
import Liability from "./household/Liability";
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from "@vuex-orm/plugin-axios";
import {Folder} from "@/store/models/household/Folder";
import {Document} from "@/store/models/household/Document";
import ClientPortalSetting from "@/store/models/ClientPortalSetting";
import PortfolioAllocator from "@/store/models/PortfolioAllocator";
import {resInt, reqInt} from "@/portal-setting-signature";

import('axios').then((axios) => {
    axios.interceptors.request.use(reqInt);
    axios.interceptors.response.use(resInt);
    VuexORM.use(
        VuexORMAxios,
        {
            axios: axios,
            baseURL: process.env.VUE_APP_BASE_URL +  '/api/v1/'
        })
});


const database = new VuexORM.Database()
database.register(Trust);
database.register(Beneficiary)
database.register(BeneficiaryAssignment);
database.register(Will);
database.register(Asset);
database.register(Individual);
database.register(IavAccount);
database.register(Property);
database.register(LifeInsurance);
database.register(Liability);
database.register(Folder);
database.register(Document);
database.register(ClientPortalSetting);
database.register(PortfolioAllocator);

export default VuexORM.install(database);
